import axios from 'axios'

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 300000,
})

service.interceptors.request.use(
    (config) => {
        const token = window.localStorage.getItem('token') || ''
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
            config.headers['Content-Type'] = 'application/json'
        }
        return config
    },
    (error) => {
        console.log(error)
        return Promise.reject()
    }
)

function clearLoginState() {
    ['token', 'chain_id', 'chain_name', 'user_name', 'role', 'cluster', 'sid', 'slogo', 'sname', 'timezone'].forEach((key) => {
        window.localStorage.removeItem(key)
    })
}

service.interceptors.response.use(
    (response) => {
        if (response.headers.authorization) {
            window.localStorage.setItem('token', response.headers.authorization.split(' ')[1])
        }
        const code = response.data && response.data.data && response.data.data.code
        const path = window.location.pathname
        const isPublicPage = path.indexOf('/login') > -1 || path.indexOf('/team/accept') > -1
        if ((code === 100002 || code === 100020) && !isPublicPage) {
            clearLoginState()
            window.location.replace('/login')
        }
        return response
    },
    (error) => {
        return Promise.reject(error)
    }
)

export default service
// /**
//  * get方法，对应get请求
//  * @param {String} url [请求的url地址]
//  * @param {Object} params [请求时携带的参数]
//  */
// export function get(url, params) {
//     return new Promise((resolve, reject) => {
//         service
//             .get(url, {
//                 params: params,
//             })
//             .then((res) => {
//                 resolve(res.data)
//             })
//             .catch((err) => {
//                 reject(err.data)
//             })
//     })
// }
// /**
//  * post方法，对应post请求
//  * @param {String} url [请求的url地址]
//  * @param {Object} params [请求时携带的参数]
//  */
// export function post(url, params) {
//     return new Promise((resolve, reject) => {
//         service
//             .post(url, params)
//             .then((res) => {
//                 resolve(res)
//             })
//             .catch((err) => {
//                 reject(err.data)
//             })
//     })
// }
